<template>
    <div class="main-container">
        <Header />
        <div class="content-container">
            <div class = "profile-toolbar">
                <el-button 
                class="edit-profile-btn"
                icon="el-icon-edit"
                type="danger" @click="handleEditProfile">修改我的信息</el-button>
            </div>
            <div class="profile-container">
                
                <div class = "profile-title">北京大学王选所校友分会校友信息登记表</div>
                <div class ="profile-info">
                    <div>分会会员编号：{{anumni.wictMemberId}}</div>
                    <div>最后保存时间：{{$formatDate(anumni.updatedTime)}}</div>
                </div>
                <div class="profile-body">
                                      
                    <table class="custom-table">
                        <colgroup>
                            <col style="width: 120px;">
                            <col style="width: 180px;">
                            <col style="width: 120px;">
                            <col style="width: 180px;">
                        </colgroup>
                        <tbody>
                            <!-- 一、个人信息 -->  
                            <tr>
                                <td class="section-header" colspan="5">一、个人信息</td>
                            </tr>
                            <tr>
                                <td class="label-cell">姓 名</td>
                                <td class="input-cell">{{anumni.fullname || "/"}}</td>
                                <td class="label-cell">性 别</td>
                                <td class="input-cell">{{getGenderName(anumni.gender)}}</td>
                                <td rowspan="6" class="photo-cell">
                                    <div class="photo-placeholder">
                                        <img v-if="anumni.avatar" :src="'/oss/' + anumni.avatar"  class="profile-photo">
                                        <div v-else>【暂无照片】</div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="label-cell">学 号</td>
                                <td class="input-cell">{{anumni.stuId || "/"}}</td>                                
                                <td class="label-cell">北大校友卡号</td>
                                <td class="input-cell">{{anumni.alumniCardId || "/"}}</td>                                
                            </tr>
                            <tr>
                                <td class="label-cell">学籍院系</td>
                                <td class="input-cell">{{anumni.college || "/"}}</td>     
                                <td class="label-cell">年 级</td>
                                <td class="input-cell">{{anumni.grade || "/"}}</td>  
                            </tr>
                            <tr>
                                <td class="label-cell">身份证号</td>
                                <td class="input-cell">{{anumni.idCard || "/"}}</td>
                                <td class="label-cell">出生日期</td>
                                <td class="input-cell">{{$formatDate(anumni.birthday, "{y}-{m}-{d}") || "/"}}</td>                                
                            </tr>
                            <tr>
                                <td class="label-cell">民 族</td>
                                <td class="input-cell">{{anumni.nation || "/"}}</td>
                                <td class="label-cell">政治面貌</td>
                                <td class="input-cell">{{anumni.politicStatus || "/"}}</td>                                
                            </tr>
                            <tr>                                
                                <td class="label-cell">籍 贯</td>
                                <td class="input-cell">{{anumni.originAddr || "/"}}</td>
                                <td class="label-cell"></td>
                                <td class="input-cell"></td>
                            </tr>
                            <!-- 二、教育信息 --> 
                            <tr>
                                <td class="section-header" colspan="5">二、教育信息</td>
                            </tr>
                            <tr>
                                <td class="label-cell">博士学习</td>
                                <td class="input-cell" colspan="4">
                                    <template v-if="doctorEducation">
                                        <div>博士学习起止时间：{{$formatDate(doctorEducation.startTime, "{y}-{m}-{d}")}} 至 {{$formatDate(doctorEducation.endTime, "{y}-{m}-{d}")}}</div>
                                        <div>导师姓名：{{doctorEducation.tutorName || "/"}}</div>
                                        <div>博士学习研究方向：{{doctorEducation.research || "/"}}</div>
                                    </template>
                                    <template v-else>
                                        <div>/</div>
                                    </template>                                                                    
                                </td>
                            </tr>                            
                            <tr>
                                <td class="label-cell">硕士学习</td>
                                <td class="input-cell" colspan="4">
                                    <template v-if="masterEducation">
                                        <div>硕士学习起止时间：{{$formatDate(masterEducation.startTime, "{y}-{m}-{d}")}} 至 {{$formatDate(masterEducation.endTime, "{y}-{m}-{d}")}}</div>                                        
                                        <div>导师姓名：{{masterEducation.tutorName || "/"}}</div>
                                        <div>硕士学习研究方向：{{masterEducation.research || "/"}}</div>
                                    </template>
                                    <template v-else>
                                        <div>/</div>
                                    </template>
                                </td>
                            </tr> 
                            <tr>
                                <td class="label-cell">博士后工作</td>
                                <td class="input-cell" colspan="4">
                                    <template v-if="postDoctorWork">
                                        <div>博士后在站起止时间：{{$formatDate(postDoctorWork.startTime, "{y}-{m}-{d}")}} 至 {{$formatDate(postDoctorWork.endTime, "{y}-{m}-{d}")}}</div>                                        
                                        <div>合作导师：{{postDoctorWork.tutorName || "/"}}</div>
                                        <div>博士后主要研究方向：{{postDoctorWork.research || "/"}}</div>
                                    </template>
                                    <template v-else>
                                        <div>/</div>
                                    </template>
                                </td>
                            </tr>
                            <tr>
                                <td class="label-cell">教职工工作</td>
                                <td class="input-cell" colspan="4">
                                    <div v-if="teacherWorks.length > 0" >
                                        <div v-for="item in teacherWorks" :key="item.id">
                                            <div>来所工作起止时间：{{$formatDate(item.startTime, "{y}-{m}-{d}")}} 至 {{$formatDate(item.endTime, "{y}-{m}-{d}")}}</div>                                        
                                            <div>主管领导：{{item.leader || "/"}}</div>
                                            <div>在所主要工作任务/研究方向：{{item.workContent || "/"}}</div>
                                        </div>
                                    </div>
                                    <template v-else>
                                        <div>/</div>
                                    </template>
                                </td>
                            </tr>
                            <tr>
                                <td class="label-cell">在所期间任职或获奖</td>
                                <td class="input-cell" colspan="4">{{anumni.honorInfo || "/"}}</td>
                            </tr>
                            <!-- 三、工作和发展情况 --> 
                            <tr>
                                <td class="section-header" colspan="5">三、工作和发展情况</td>
                            </tr>
                            <tr>
                                <td class="label-cell">目前工作</td>
                                <td class="input-cell" colspan="4">
                                    <template v-if="currentCareer">
                                        <div>1.目前从事的行业或工作领域：{{currentCareer.industry || "/"}}</div>
                                        <div>2.所在地/城市：{{currentCareer.city || "/"}}</div>
                                        <div>3.目前单位名称：{{currentCareer.company || "/"}}</div>
                                        <div>4.职务/职称：{{currentCareer.jobTitle || "/"}}</div>
                                    </template>
                                    <template v-else>
                                        <div>/</div>
                                    </template>
                                </td>
                            </tr>
                            <tr>
                                <td class="label-cell">主要履历</td>
                                <td class="input-cell" colspan="4">
                                    <template v-if="careerList && careerList.length > 0">
                                        <div v-for="item in careerList" :key="item.id">
                                            {{item.industry}} {{item.city}} {{item.company}} {{item.jobTitle}}
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div>/</div>                                        
                                    </template>
                                </td>
                            </tr>
                            <!-- 四、校友联络 --> 
                            <tr>
                                <td class="section-header" colspan="5">四、校友联络</td>
                            </tr>
                            <tr>
                                <td class="label-cell">手机号</td>
                                <td class="input-cell" colspan="1">{{anumni.mobile || "/"}}</td>
                                <td class="label-cell">常用邮箱</td>
                                <td class="input-cell" colspan="2">{{anumni.email || "/"}}</td>
                            </tr>
                            <tr>
                                <td class="label-cell">微信联络</td>
                                <td class="input-cell" colspan="4">
                                    <div>本人微信号：{{anumni.wxNo || "/"}}</div>
                                    <div>已加入WICT校友大群：{{anumni.wxGroup || "/"}}</div>
                                </td>
                            </tr>
                            <tr>
                                <td class="label-cell">校友联络</td>
                                <td class="input-cell" colspan="4">
                                    <div>年级联络人姓名：{{anumni.gradeContact || "/"}}</div>
                                    <div>联系较多的校友有：{{anumni.linkAlumni || "/"}}</div>
                                </td>
                            </tr>
                            <tr>
                                <td class="label-cell">业余爱好</td>
                                <td class="input-cell" colspan="4">{{anumni.hobby || "/"}}</td>
                            </tr>
                            <!-- 五、对王选所校友分会的期望和建议 --> 
                            <tr>
                                <td class="section-header" colspan="5">五、对王选所校友分会的期望和建议</td>
                            </tr>
                            <tr>                
                                <td class="label-cell">期望与建议</td>                
                                <td class="input-cell" colspan="4">{{anumni.suggest || "/"}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="profile-footer">
                    <div>“科教兴国，人才强国。”——王选  二〇〇六年一月三日</div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>
<script>
import Header from "@/components/header";
import Footer from "@/components/footer";
import { getMyProfile } from "@/api/alumniApi";
import { getGenderName } from "@/utils/constUtil";

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      anumni: {},
      // 博士学习经历
      doctorEducation: {},
      // 硕士学习经历
      masterEducation: {},
      // 博士后工作经历
      postDoctorWork: {},
      // 教职工工作
      teacherWorks: [],
      // 当前工作
      currentCareer: {},
      // 主要履历
      careerList: [],
    }
  },
  created() {
    this.$nextTick(() => {
      this.loadData();
    });
  },
  methods: {
    getGenderName,
    loadData(){
        getMyProfile().then(res => {
            if (res.code === 200) {
                this.anumni = res.data;
                if(this.anumni && this.anumni.isSubmit === 0){
                    // 直接跳转到提交页面
                    this.$router.push("/profile-form");
                }
                this.initData();
            }else{
                this.$message.error(res.msg);
                this.anumni = {};
            }
        }).catch(err => {
            this.$message.error(err.message);
            this.anumni = {};
        });
    },
    // 初始化数据
    initData(){
        if (!this.anumni) {
            return;
        }
        // 教育信息
        if(this.anumni.educationList && this.anumni.educationList.length > 0){
            for(let item of this.anumni.educationList){
                if(item.eduType === 2){
                    this.masterEducation = item || {};
                }else if(item.eduType === 3){
                    this.doctorEducation = item || {};
                }else if(item.eduType === 4){
                    this.postDoctorWork = item || {};
                }
            }
        }
        // 教职工工作
        this.teacherWorks = this.anumni.workList || [];
        // 当前工作
        if(this.anumni.careerList && this.anumni.careerList.length > 0){
            this.currentCareer = this.anumni.careerList[0] || {};
            if(this.anumni.careerList.length > 1){
                this.careerList = this.anumni.careerList.slice(1);
            }
        }
    },

    handleEditProfile(){
        this.$router.push({
            path: "/profile-form",
        });
    },
  },
}
</script>
<style scoped>
.profile-container {
  padding: 20px;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  max-width: 800px;
}
.profile-toolbar {
    width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: nowrap;
  box-sizing: border-box;
}
.edit-profile-btn {
  background: rgba(148, 8, 11, 1);  
  outline: none;
  border: none;
}
.edit-profile-btn:hover {
  opacity: 0.8;
  background: rgba(148, 8, 11, 1);  
}
.profile-title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
}
.profile-info {
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
}
.profile-body {
  margin-bottom: 20px;
}
.profile-footer {
  text-align: center;
  margin-top: 20px;
  color: #666;
  font-size: 12px;
}
.header-section {
  position: relative;
  text-align: center;
  margin-bottom: 20px;
  border-bottom: 2px solid #333;
  padding-bottom: 10px;
}
/* 表格通用样式 - 核心部分 */

.custom-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
  table-layout: fixed; /* 固定布局防止内容撑开 */
}

.custom-table td {
  border: 1px solid #000; /* 黑色实线边框 */
  padding: 8px;
  font-size: 14px;
  color: #333;
}

/* 左侧标签列 */
.label-cell {
  background-color: #f0f2f5; /* 浅灰背景 */
  width: 100px;
  text-align: center;
  font-weight: bold;
  white-space: wrap;
}

/* 区域标题栏样式 */
.section-header {
  background-color: #f0f2f5; 
  color: #303133;            
  font-weight: bold;         
  text-align: center;        
  padding: 8px 0;             
  letter-spacing: 2px;  
}

/* 输入单元格 */
.input-cell {
  padding: 10px !important;  
}

/* 照片占位符 */
.photo-cell {
  width: 120px;
  text-align: center;
  vertical-align: middle;
  color: #1890ff;
}
.photo-cell img {
  width: 100%;
  height: 100%;
}
.photo-placeholder {
  display: inline-block;
}

/* 垂直居中辅助类 */
.vertical-middle {
  vertical-align: middle;
}

/* 子行样式（用于一行内有多个输入项的情况） */
.sub-row {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.sub-row-text {
  margin-bottom: 5px;
  color: #666;
  font-style: italic;
}
</style>
